// Which run the page shows, read from the location and nothing else (#159).
//
// The SPA is served by the control plane at `/` and every path under it that
// is not an API route (`control_plane/api.py`), so a run page is a URL a
// person can paste: `/runs/<run_id>`. The stream it opens is the API's
// `/runs/<run_id>/events/stream` (`contracts/stream.ts`), which is why the
// page path mirrors the resource path — one id, two readers, the same
// segment. A location with no run in it renders the picker instead.

const RUN_PATH = /^\/runs\/([^/]+)\/?$/;

/** The run id in `pathname`, or null when the location names none. */
export function runIdFromLocation(pathname: string): string | null {
  const match = RUN_PATH.exec(pathname);
  if (match === null) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

/** The page path for a run: the inverse of `runIdFromLocation`. */
export function runPagePath(runId: string): string {
  return `/runs/${encodeURIComponent(runId)}`;
}
